<ng-container *ngIf="formGroup" [formGroup]="formGroup">
  <div class="p-2">
    <div class="row pb-2" *ngIf="formGroup.get('isDevan')">
      <label class="col-3 mt-2 text-end mogo-bold">Devan is Required:</label>
      <div class="col-1 mt-1">
        <input type="checkbox" formControlName="isDevan" />
      </div>
    </div>

    <div class="row pb-2" *ngIf="getFormPartial('plannedDevanType') && getFormPartial('isDevan')!.value">
      <label class="col-3 mt-2 text-end mogo-bold">Devan Type:</label>
      <div class="col-9">
        <ng-select id="plannedDevanTypeDropDown" formControlName="plannedDevanType"
          [items]="availableDevanTypes$ | async" bindLabel="name" placeholder="Select Devan Type">
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="text-md-start">
              {{ item.name }}
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="row pb-2" *ngIf="getFormPartial('plannedDevanDate') && getFormPartial('isDevan')!.value">
      <label class="col-3 mt-2 text-end mogo-bold">Planned Devan Date:</label>
      <div class="col-9">
        <app-custom-date-range-picker id="plannedDevanDate" [formControl]="getFormPartial('plannedDevanDate')"
          placeholder="Select Planned Devan date">
        </app-custom-date-range-picker>

        <small class="text-start"
          *ngIf="formGroup.get('plannedDevanDate')!.invalid && (formGroup.get('plannedDevanDate')!.dirty || formGroup.get('plannedDevanDate')!.touched)">
          <div
            *ngIf="(getFormPartial('plannedDevanDate') && getFormPartial('isDevan')!.value) && formGroup.get('plannedDevanDate')!.hasError('dateNotLess')"
            class="text-danger">The Devan date cant be before the full delivery date</div>
        </small>
      </div>
    </div>
  </div>
</ng-container>